import Box from '@mui/material/Box';
import React from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import CustomTabs from '../../ui-parts/CustomTabs';
import MetadataFilesSlider from '../../ui-parts/MetadataFilesSlider';
import MetadataItAppsSlider from '../../ui-parts/MetadataItAppsSlider';

/** MyMine Version2.0 ServiceLv3画面新規追加
 * ServiceLv3MetadataTabs Component
 */
export const ServiceLv3MetadataTabs = ({
  controlSettings,
  screenId,
  metadataContents,
  callbackFileFavorite,
  callbackItAppFavorite,
  setIsLoading,
}) => {

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [selectedSlideMetadataList, setSelectedSlideMetadataList] = React.useState([]);

  const tabPropList =
    [
      {
        tabCaption: controlSettings.LabelList.lblDescription,
        tabContents:
          <DesriptionTab
            controlSettings={controlSettings}
            metadataContents={metadataContents} />,
      },
      {
        tabCaption: controlSettings.LabelList.lblRelatedFiles,
        tabContents:
          <RelatedFileTab
            screenId={screenId}
            controlSettings={controlSettings}
            metadataContents={metadataContents}
            callbackFavorite={callbackFileFavorite}
            setIsLoading={setIsLoading}
            selectedSlideMetadataList={selectedSlideMetadataList}
            setSelectedSlideMetadataList={setSelectedSlideMetadataList} />,
      },
      {
        tabCaption: controlSettings.LabelList.lblITApps,
        tabContents:
          <ItAppTab
            screenId={screenId}
            controlSettings={controlSettings}
            metadataContents={metadataContents}
            callbackFavorite={callbackItAppFavorite}
            setIsLoading={setIsLoading}
            selectedSlideMetadataList={selectedSlideMetadataList}
            setSelectedSlideMetadataList={setSelectedSlideMetadataList} />,
      },
    ];

  return (
    <Box sx={{ borderColor: 'divider', bgcolor: 'background.paper', }}>
      <CustomTabs
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        tabCaptionList={
          tabPropList.map((x, i) => { return { id: i, caption: x.tabCaption } })
        }
        tabContents=
        {
          <Box className='p-2'
            sx={{
              minHeight: 300,
              ':has(.slick-slider)': {
                display: 'grid',
                alignItems: 'center',
              }
            }}>
            {tabPropList[selectedTabIndex].tabContents}
          </Box>
        }
      />
    </Box>
  );
}

const DesriptionTab = ({ controlSettings, metadataContents }) =>
  <MyMLabel sx={{px:'10px'}}>{controlSettings.LabelList[`lblDescriptionValue_${metadataContents.MetadataId}`]}</MyMLabel>

const RelatedFileTab = ({ controlSettings, metadataContents, ...other }) =>
  metadataContents.BoxFileList.length === 0
    ? <MyMLabel className='fw-bold'>{controlSettings.LabelList.lblComingsoon}</MyMLabel>
    : <Box className='d-flex align-items-center h-100'>
      <MetadataFilesSlider
        key={metadataContents.BoxFileList.map(x => x.FileId)}
        controlSettings={controlSettings}
        metadataId={metadataContents.MetadataId}
        fileList={metadataContents.BoxFileList}
        {...other}
      />
    </Box>

const ItAppTab = ({ controlSettings, metadataContents, ...other }) =>
  metadataContents.ItAppList.length === 0
    ? <MyMLabel className='fw-bold'>{controlSettings.LabelList.lblComingsoon}</MyMLabel>
    : <Box className='d-flex align-items-center h-100'>
      <MetadataItAppsSlider
        key={metadataContents.ItAppList.map(x => x.ItAppId)}
        controlSettings={controlSettings}
        metadataId={metadataContents.MetadataId}
        itAppList={metadataContents.ItAppList}
        {...other}
      />
    </Box>
